class ProductRecommendations extends HTMLElement {
  observer = undefined

  constructor() {
    super()
    this.swiper = null
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId)
  }

  init() {
    const swiperNextButton = this.querySelector('.js-swiper-button-next')
    const swiperPrevButton = this.querySelector('.js-swiper-button-prev')

    if (!this.swiperElement) return
    this.swiper = new Swiper(this.swiperElement, {
      slidesPerView: 1.4,
      spaceBetween: 10,
      loop: false,
      lazy: true,
      mousewheel: false,
      breakpoints: {
        500: {
          slidesPerView: 2.4,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3.4,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 4.4,
          spaceBetween: 10,
        },
        1200: {
          slidesPerView: 5.4,
          spaceBetween: 10,
        },
      },
      navigation: {
        nextEl: swiperNextButton,
        prevEl: swiperPrevButton,
      },
      on: {
        afterInit: () => {
          setTimeout(() => {
            swiperPrevButton.classList.remove('loading')
            swiperNextButton.classList.remove('loading')
          }, 100)
        },
      },
    })
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this)
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return
        observer.unobserve(this)
        this.loadRecommendations(productId)
      },
      { rootMargin: '0px 0px 400px 0px' },
    )
    this.observer.observe(this)
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('product-recommendations')

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
          this.swiperElement = this.querySelector('.js-swiper')
          this.init()
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
}

customElements.define('product-recommendations', ProductRecommendations)
